(function () {
  const ROWS = 6; // ILE W DÓŁ – tylko popup (3. poziom)

  function fitGrandchildMenus() {
    document
      .querySelectorAll('#header-second-nav .dropdown-menu.grandchild-menu')
      .forEach(menu => {

        const list = menu.querySelector(':scope > .menu-list');
        if (!list) return;

        const items = Array.from(
          list.querySelectorAll(':scope > li.menu-item')
        ).filter(li => li.offsetParent !== null);

        const count = items.length || 1;
        const cols = Math.max(1, Math.ceil(count / ROWS));

        // 🔥 HARD FORCE GRID (przebija wszystko)
        list.style.setProperty('display', 'grid', 'important');
        list.style.setProperty('grid-auto-flow', 'column', 'important');
        list.style.setProperty('grid-template-rows', `repeat(${ROWS}, auto)`, 'important');
        list.style.setProperty(
          'grid-template-columns',
          `repeat(${cols}, minmax(240px, 1fr))`,
          'important'
        );

        menu.style.setProperty('width', 'fit-content', 'important');
        menu.style.setProperty('max-width', 'min(92vw, 1100px)', 'important');
      });
  }

  const root = document.querySelector('#header-second-nav') || document.body;
  const obs = new MutationObserver(fitGrandchildMenus);
  obs.observe(root, { subtree: true, childList: true, attributes: true });

  window.addEventListener('load', fitGrandchildMenus);
  window.addEventListener('resize', fitGrandchildMenus);
})();